/* Appends DECKED-style utility links to the right of the announcement bar. */
(function(){
  var LINKS = [["Find a Dealer", "/pages/where-to-buy"], ["Become a Dealer", "/pages/where-to-buy"], ["Contact Us", "/pages/contact-us"]];
  function build(){
    var bar = document.querySelector('.announcement-bar, [class*="announcement-bar"]');
    if(!bar || bar.querySelector('.xg-util')) return !!bar;
    var nav = document.createElement('nav');
    nav.className = 'xg-util';
    nav.setAttribute('aria-label', 'Quick links');
    LINKS.forEach(function(l){
      var a = document.createElement('a');
      a.href = l[1]; a.textContent = l[0];
      nav.appendChild(a);
    });
    bar.appendChild(nav);
    bar.classList.add('xg-has-util');
    return true;
  }
  if(document.readyState !== 'loading') build();
  else document.addEventListener('DOMContentLoaded', build);
  var n = 0, iv = setInterval(function(){ if(build() || ++n > 20) clearInterval(iv); }, 250);
})();

/* --- at-top flag --- */
/* The theme gives the sticky header a white background once you scroll but
   adds no class for it, so the overlay treatment (white nav, inverted logo,
   position:absolute) has to be switched off some other way. Flag the top of
   the page on <body> and scope all of it to that. */
(function(){
  var t = false;
  function sync(){
    t = false;
    var atTop = (window.scrollY || document.documentElement.scrollTop) < 8;
    document.body.classList.toggle('xg-at-top', atTop);
  }
  function onScroll(){ if(!t){ t = true; requestAnimationFrame(sync); } }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  if(document.readyState !== 'loading') sync();
  else document.addEventListener('DOMContentLoaded', sync);
})();
